<template>
  <div>
    <input
      type="file"
      name="filename"
      id="open"
      ref="open"
      @change="specifiName($event)"
      style="display: none"
      :multiple="multiple"
      :accept="accept"
    />
    <div class="select" :style="selectStyle" @click="openFile">
      <div class="label">{{ label }}</div>
      <a-icon type="upload" style="color: #0073ff" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    //框样式
    selectStyle: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: "请选择要上传的模版",
    },
    //限制文件类型
    accept: {
      type: String,
      default: "",
    },
  },
  methods: {
    //选择的文件地址回调
    specifiName(e) {
      this.$emit("change", e);
    },
    openFile() {
      const fileInput = document.getElementById("open");
      fileInput.click();
    },
  },
};
</script>

<style scoped>
.select {
  height: 54px;
  background: #fafbff;
  border: 1px solid #f5f6fa;
  border-radius: 4px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.select .label {
  color: #9ba2ab;
  font-size: 16px;
}
</style>